<div class="compare-page">
  <div class="compare-header">
    <h1>Compare countries</h1>
    <p>What each country calls the same field, side by side.</p>
  </div>

  <div class="toolbar">
    <app-option-select [options]="countryOptions" [(ngModel)]="leftCountry" name="leftCountry" />

    <button class="swap-btn" type="button" (click)="swap()" title="Swap sides" aria-label="Swap sides">
      <span class="material-icons">swap_horiz</span>
    </button>

    <app-option-select [options]="countryOptions" [(ngModel)]="rightCountry" name="rightCountry" />

    <input
      [(ngModel)]="termSearch"
      name="termSearch"
      (ngModelChange)="onSearchChange()"
      placeholder="Filter by term (e.g. bizStep)"
      class="term-search"
    />
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (generalTerms().length === 0) {
    <app-empty-state message="No general terms configured yet." />
  } @else if (availableCountries().length < 2) {
    <app-empty-state message="Need at least two configured countries to compare." />
  } @else {
    <table>
      <thead>
        <tr>
          <th>{{ countryLabel(leftCountry) }}</th>
          <th>General term</th>
          <th>{{ countryLabel(rightCountry) }}</th>
        </tr>
      </thead>
      <tbody>
        @for (term of pagedTerms; track term.id) {
          <tr>
            <td>
              @if (isOverride(term.term, leftCountry)) {
                <code>{{ cell(term.term, leftCountry) }}</code>
              } @else {
                <span class="muted">{{ term.term }} (default)</span>
              }
            </td>
            <td><code>{{ term.term }}</code></td>
            <td>
              @if (isOverride(term.term, rightCountry)) {
                <code>{{ cell(term.term, rightCountry) }}</code>
              } @else {
                <span class="muted">{{ term.term }} (default)</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }} terms</span>
      </div>
    </div>
  }
</div>
